export default {
    setButton(state: { buttons_allowed: Array<any> }, data: Array<any>) {
        state.buttons_allowed = data;
    }
}
